import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import aboutImg from './img/about-img.avif';
import css from './AboutPage.module.css';

const SectionAbout = () => {
  return (
    <div className={css.sectionAbout}>
      <h2 className={css.aboutTitle}>
        <FormattedMessage
          id="AboutPage.aboutTitle"
          values={{
            textBreak: <br />,
          }}
        />
      </h2>
      <div className={css.aboutContent}>
        <img className={css.aboutImg} loading="lazy" src={aboutImg} alt="Our story" />
        <p className={css.aboutText}>
          <FormattedMessage
            id="AboutPage.aboutText"
            values={{
              textBreak: <br />,
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default SectionAbout;
